// theme.announcement = (function () {
//   function announcementModule(element) {
//     const announcement = {
//       open: document.getElementById("announcement-more-info"),
//       close: document.querySelector(".close__announcement--bar"),
//       wrapper: document.querySelector(".announcement-collapsible-content"),
//     };

//     // Hide the announcement bar
//     const hide = () => {
//       announcement.wrapper.classList.remove("open");
//       announcement.open.classList.remove("show--dropdown");
//       slideUp(announcement.wrapper);
//     };

//     // open the announcement bar
//     const open = () => {
//       announcement.wrapper.classList.add("open");
//       announcement.open.classList.add("show--dropdown");
//       slideDown(announcement.wrapper);
//     };

//     // Click open event
//     announcement.open?.addEventListener("click", (event) => {
//       event.preventDefault();
//       let isOpen = announcement.wrapper.classList.contains("open")
//         ? true
//         : false;
//       if (isOpen) {
//         hide();
//       } else {
//         open();
//       }
//     });

//     // Click close event
//     announcement.close?.addEventListener("click", (event) => {
//       event.preventDefault();
//       hide();
//     });
//   }
//   return announcementModule;
// })();


theme.announcement = (function () {
  function announcementModule() {
    const announcements = {
      open: document.querySelectorAll(".announcement-bar"),
      close: document.querySelectorAll(".close__announcement--bar"),
      wrappers: document.querySelectorAll(".announcement-collapsible-content"),
    };

    const hideAll = () => {
      announcements.wrappers.forEach((wrapper) => {
        wrapper.classList.remove("open");
        slideUp(wrapper);
      });
      announcements.open.forEach((openButton) => {
        openButton.classList.remove("show--dropdown");
      });
    };

    const openAll = () => {
      announcements.wrappers.forEach((wrapper) => {
        wrapper.classList.add("open");
        slideDown(wrapper);
      });
      announcements.open.forEach((openButton) => {
        openButton.classList.add("show--dropdown");
      });
    };

    // Click open event for all buttons
    announcements.open.forEach((openButton) => {
      openButton.addEventListener("click", (event) => {
        event.preventDefault();
        const anyOpen = Array.from(announcements.wrappers).some(wrapper =>
          wrapper.classList.contains("open")
        );
        
        if (anyOpen) {
          hideAll();
        } else {
          openAll();
        }
      });
    });

    // Click close event for all close buttons
    announcements.close.forEach((closeButton) => {
      closeButton.addEventListener("click", (event) => {
        event.preventDefault();
        hideAll();
      });
    });
  }
  
  return announcementModule;
})();
